<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
// import { api } from '@/api/common/instances';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // Removed.by.KWShin.2024.03.08. liquidChartable.js에 이미 선언되어 있음.
    // title: String,
    // BEGIN::Rmnoved and Added.by.KWShin.2024.03.28.
    // sstmId: {
    //   type: String,
    //   required: true,
    // },
    // timestamp: {
    //   type: Number,
    //   required: true,
    // },
    value: {
      type: Array,
      required: true,
    },
    // FINISH::Rmnoved and Added.by.KWShin.2024.03.28.
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.03.12.
    title() {
      return this.$t('dv.title.upd.error');
    },
    // FINISH::Added.by.KWShin.2024.03.12.
  },
  watch: {
    // BEGIN::Rmnoved and Added.by.KWShin.2024.03.28.
    // timestamp(data) {
    //   this.fetchData(data);
    // },
    value(data) {
      this.setData(data);
    },
    // FINISH::Rmnoved and Added.by.KWShin.2024.03.28.
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  methods: {
    // BEGIN::Modified.by.KWShin.2024.03.28.
    // timestamp를 동기화하여 DB를 읽어오던 것을,
    // 어차피 그리드 쪽에서 데이터를 읽어오므로 그 데이터를 받아서
    // 보여주는 방식으로 바꿈.
    /*
    async fetchData(ymdhms) {
      const params = {
        beginYmdhms: ymdhms,
        endYmdhms: ymdhms,
        sstmId: this.sstmId,
        motletCode: 'C_ABAP_UPD_REC',
      };
      const {
        data: [
          {
            data: [result],
          },
        ],
      } = await api.get('/motlet-data/chart', { params });
      this.data.value = result['count'];
    },
    */
    setData(dataList) {
      if (dataList.length > 0) {
        this.data.value = dataList.length;
      } else this.data.value = 0;
    },
    // FINISH::Modified.by.KWShin.2024.03.28.
  },
};
</script>
